import { ReactComponent as Instagram } from "Assets/icons/social-instagram.svg";
import { ReactComponent as Linkedin } from "Assets/icons/social-linkedin.svg";

import "./Socials.scss";
import { trackEvent } from "Services/Analytics/trackEvent";

const Socials = (prop: any) => {
  return (
    <div className="socials">
      <a
        href="https://www.instagram.com/baipro.ingenieria/"
        aria-label="Instagram"
        target="_blank"
        rel="noreferrer"
        onClick={() => trackEvent("instagram_button")}
      >
        <Instagram className="socials_icons" />
      </a>
      {/*       <a
        href="https://www.facebook.com/profile.php?id=100064712179196"
        target="_blank"
        rel="noreferrer"
      >
        <Facebook className="socials_icons" />
      </a> */}
      <a
        href="https://www.linkedin.com/company/baiproingenieria"
        target="_blank"
        rel="noreferrer"
        aria-label="LinkedIn"
        onClick={() => trackEvent("linkedin_button")}
      >
        <Linkedin className="socials_icons" />
      </a>
    </div>
  );
};

export default Socials;
